import {
  VR_BASIC_SETTING,
  VR_VIEW_SETTING,
  VR_HOTSPOT_SETTING,
  VR_INFO_PATH
} from '@constant'

export const menuConfig = [
  {
    value: VR_BASIC_SETTING,
    text: '基础',
    icon: 'iconbasic',
    to: VR_INFO_PATH
  },
  {
    value: VR_VIEW_SETTING,
    text: '视角',
    icon: 'iconview',
    to: '/localMerchant/vr/manage/view'
  },
  {
    value: VR_HOTSPOT_SETTING,
    text: '热点',
    icon: 'iconhotspot',
    to: '/localMerchant/vr/manage/hotspot'
  }
]
